import React from 'react';

const emojiIdFromCode = {};

class EmojiHelper {

    static init(emojis) {
        if (emojis != null) {
            for (var i in emojis) {
                const e = emojis[i];
                //console.log(e)
                if (e.unified != null) {
                    emojiIdFromCode[e.unified.toLowerCase()] = e.id;
                }
            }
        }
    }

    static lookup(unifiedCode) {
        //console.log(unifiedCode);
        const id = emojiIdFromCode[unifiedCode.trim().toLowerCase()];
        return id != null ? id : 'grey_question';
    }
}

export default EmojiHelper;